import md5 from 'md5';
import { Button } from 'react-bootstrap';

const AssinaturaEletronica = ({
  data,
  nome,
  showPrintButton = true,
  imprimirLaudo = () => window.print(),
}) => {
  const payload = typeof data === 'string' ? data : JSON.stringify(data || {});
  const hash = md5(payload);

  return (
    <div className="text-center">
      <p className="mb-2">
        <i className="text-muted">Assinatura Digital: </i>
        <strong className="text-break">{hash}</strong>
      </p>
      <p className="mt-2">
        Conferido e assinado eletronicamente por:
        <strong> Dr. {nome}</strong>
      </p>
      {showPrintButton && <Button onClick={imprimirLaudo}>Imprimir</Button>}
    </div>
  );
};

export default AssinaturaEletronica;
